import styled from 'styled-components';

export const ChartContainer = styled.div`
  container-type: inline-size;
  overflow: hidden;
`;

// The 1px overhang is clipped by the container, dropping the outer dividers.
export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: calc(100% + 1px);
  margin-bottom: -1px;

  @container (min-width: 984px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @container (min-width: 1312px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @container (min-width: 1640px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const ChartItem = styled.div`
  min-width: 0;

  border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`;
